document.addEventListener('DOMContentLoaded', function() {
    var productParameters = document.querySelector('.product-parameters');
    var controlsGroup = productParameters.querySelector('.product-form__controls-group');
    var labels = controlsGroup.querySelectorAll('label');

    if (labels.length === 1) {
        productParameters.style.display = 'none';
    }
});

document.addEventListener('DOMContentLoaded', function() {
  var facetsMain = document.querySelector('.facets__main');

  if (facetsMain) {
    window.addEventListener('scroll', function() {
      if (window.scrollY > facetsMain.offsetTop) {
        facetsMain.classList.add('sticky');
      } else {
        facetsMain.classList.remove('sticky');
      }
    });
  }
});




    document.addEventListener("DOMContentLoaded", function() {
    const removeFiltersButton = document.querySelector('facet-remove');

    if (removeFiltersButton) {
        const buttonLink = removeFiltersButton.querySelector('a');

        buttonLink.addEventListener('click', function(event) {
            event.preventDefault();

            // Trova tutti gli input con la classe 'type-filter__input' e rimuovi l'attributo 'checked'
            const checkboxes = document.querySelectorAll('.type-filter__input');
            checkboxes.forEach(function(checkbox) {
                checkbox.removeAttribute('checked');
            });
        });
    }
});



document.addEventListener("DOMContentLoaded", function() {
    const removeFiltersButton = document.querySelector('facet-remove');

    if (removeFiltersButton) {
        const buttonLink = removeFiltersButton.querySelector('a');

        buttonLink.addEventListener('click', function(event) {
            event.preventDefault();

            // Seleziona l'elemento span con la classe 'button-simpl__label' e nascondilo
            const labelSpan = buttonLink.querySelector('.button-simpl__label');
            if (labelSpan) {
                labelSpan.style.display = 'none';
            }
        });
    }
});


document.addEventListener("DOMContentLoaded", function() {
    const removeFiltersButton = document.querySelector('.button-simpl__label');

    if (removeFiltersButton) {
        removeFiltersButton.addEventListener('click', function(event) {
            event.preventDefault();

            // Seleziona tutti gli elementi label con le classi 'type-filter__label' e 'facets-checkbox--disabled'
            const disabledLabels = document.querySelectorAll('.type-filter__label.facets-checkbox--disabled');
            
            // Rimuovi la classe 'facets-checkbox--disabled' da tutti gli elementi label selezionati
            disabledLabels.forEach(function(label) {
                label.classList.remove('facets-checkbox--disabled');

                // Trova l'elemento input all'interno del label e rimuovi l'attributo 'disabled'
                const input = label.querySelector('.type-filter__input');
                if (input) {
                    input.removeAttribute('disabled');
                }
            });
        });
    }
});

document.addEventListener('DOMContentLoaded', function() {
    if (window.innerWidth <= 768) {  // Esegui solo se la larghezza della finestra è 768px o inferiore
        document.querySelectorAll('.slideshow-section').forEach(el => {
            const computedStyle = window.getComputedStyle(el);

            const paddingTop = parseInt(computedStyle.paddingTop);
            const paddingBottom = parseInt(computedStyle.paddingBottom);

            if (!isNaN(paddingTop)) {
                el.style.paddingTop = (paddingTop / 4) + 'px';
            }

            if (!isNaN(paddingBottom)) {
                el.style.paddingBottom = (paddingBottom / 4) + 'px';
            }
        });

        document.querySelectorAll('.blockqoute-section').forEach(el => {
            const computedStyle = window.getComputedStyle(el);

            const paddingTop = parseInt(computedStyle.paddingTop);
            const paddingBottom = parseInt(computedStyle.paddingBottom);

            if (!isNaN(paddingTop)) {
                el.style.paddingTop = (paddingTop / 4) + 'px';
            }

            if (!isNaN(paddingBottom)) {
                el.style.paddingBottom = (paddingBottom / 4) + 'px';
            }
        });
    }
});



document.addEventListener('DOMContentLoaded', function() {
    const sliders = document.querySelectorAll('.type-filter__container');

    const apply = (slider) => {
      let isDown = false;
      let startX;
      let scrollLeft;
  
      slider.addEventListener('mousedown', (e) => {
          isDown = true;
          slider.style.setProperty('cursor', 'grabbing', 'important');
          startX = e.pageX - slider.offsetLeft;
          scrollLeft = slider.scrollLeft;
          e.preventDefault(); // Previene la selezione del testo
      });
  
      slider.addEventListener('mouseleave', () => {
          isDown = false;
          slider.style.setProperty('cursor', 'grab', 'important');
      });
  
      slider.addEventListener('mouseup', () => {
          isDown = false;
          slider.style.setProperty('cursor', 'grab', 'important');
      });
  
      slider.addEventListener('mousemove', (e) => {
          if (!isDown) return;
          e.preventDefault();
          const x = e.pageX - slider.offsetLeft;
          const walk = (x - startX) * 1; // Aumentato leggermente per una migliore risposta
          slider.scrollLeft = scrollLeft - walk;
      });
  
      // Prevenire il click sui label durante lo scroll
      let scrolling = false;
      slider.addEventListener('scroll', () => {
          scrolling = true;
          clearTimeout(slider.scrollTimeout);
          slider.scrollTimeout = setTimeout(() => {
              scrolling = false;
          }, 100);
      });
  
      slider.querySelectorAll('.type-filter__label').forEach(label => {
          label.addEventListener('click', (e) => {
              if (scrolling) {
                  e.preventDefault();
              }
          });
      });
  
      // Assicurarsi che il cursore sia impostato su 'grab' all'inizio
      slider.style.setProperty('cursor', 'grab', 'important');
    };

    sliders.forEach(apply);
});
